import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  stepTitle: {
    defaultMessage: 'Get onboarding support.',
    description: 'Title for the FTU wizard phone number capture step',
    id: 'lwQyaP',
  },
  stepDescription: {
    defaultMessage: 'Add your phone number to stay informed with alerts and get access to setup help.',
    description: 'Description for the FTU wizard phone number capture step',
    id: 'ZYL3T8',
  },
  successMessage: {
    defaultMessage: 'Phone number saved successfully',
    description: 'Success notification when phone number is saved in FTU wizard',
    id: 'l1+Nxq',
  },
  errorMessage: {
    defaultMessage: 'Failed to save phone number. Please try again.',
    description: 'Error notification when phone number fails to save in FTU wizard',
    id: 'lXZ/2A',
  },
});
